import React, { Component } from 'react'
import { $legislationGroup } from 'services/LegislationService'
import connect from 'components/shared/connect'
import { mapResponse } from 'front-end-core/helpers/dataflow'
import Title from 'components/legislation/Title'
import SectionHeader from 'components/legislation/SectionHeader'
import AccordionWrapperContainer from 'redux/containers/components/accordion/AccordionWrapperContainer'
import { map } from 'rxjs/operators'

export const propsToStream = ({ selectedIds, aol }) =>
  $legislationGroup(selectedIds[0].split(':')[0], selectedIds, null, aol).pipe(map(mapResponse(group => ({ group }))))

@connect(propsToStream)
class Wrapper extends Component {
  render () {
    const { group = [] } = this.props
    const cxNames = {
      accordionContainer: 'bg-white pb8 mb6',
      groupHeader: {
        depthStyle: (depth) => {
          switch (depth) {
            case 2:
              return 'bg-medium-purple white b--medium-purple'
            default:
              return 'bg-ghost-grey b--medium-purple'
          }
        },
        iconDepthStyle: depth => {
          switch (depth) {
            case 2:
              return 'white'
            default:
              return 'black o-80'
          }
        }
      },
      contentHeader: {
        borderColor: 'b--medium-purple'
      },
      content: {
        divider: 'bt--medium-purple'
      },
      borderColor: 'b--dark-orchid'
    }

    return (
      <AccordionWrapperContainer
        {...{ group, cxNames }}
        eventCategory='Legislation'
        title={<Title />}
        copyright={<Copyright />}
        styleTitle={false}
        SectionHeaderOverride={SectionHeader}
      />
    )
  }
}

const Copyright = () => (
  <span>
    &copy;Crown copyright {new Date().getFullYear()}.
    Legislation licensed under the terms of the Open Government Licence
    (
    <a
      href='http://www.nationalarchives.gov.uk/doc/open-government-licence/version/3'
      target='_blank'
      rel='noopener noreferrer'
    >
      http://www.nationalarchives.gov.uk/doc/open-government-licence/version/3
    </a>
    ).
  </span>
)

export default Wrapper
